<template>
  <div class="card card-custom card-stretch mb-5">
    <div class="card-header align-items-start border-0 mt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder text-dark fs-3">
          Моя выгода при продаже компании или IPO
        </span>
      </h3>
    </div>
    <div class="card-body d-flex flex-column justify-content-between">
      <div class="row">
        <div class="col-sm-6 mb-5">
          <label class="form-label">
            <span>При рыночной<br/>оценке</span>
            <HelpMessage>Выручка прошлого года × 5</HelpMessage>
          </label>
          <MoneyInput v-model="revenue" class="form-control form-control-solid form-control-sm"/>
          <small class="text-muted">Внеси рыночную оценку</small>
        </div>
        <div class="col-sm-6">
          <label class="form-label">
            <span>Моя выгода<br/>составит</span>
            <HelpMessage>{{ benefitTooltip }}</HelpMessage>
          </label>
          <span class="form-control benefit text-primary">
            <Money :value="benefit"/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.benefit {
  border: 0;
  padding: 0.25rem 0rem;
  border-radius: 0.65rem;
  display: inline-block;
  font-weight: bold;
  font-size: 1.45rem;
}
</style>

<script>
import Percent from "./components/Percent";
import Money from "./components/Money";
import MoneyInput from "./components/MoneyInput";
import HelpMessage from "./components/HelpMessage";

import {money, percent as formatPercent} from "../helpers/formatter";
import {lastYear} from "../helpers/year";

export default {
  components: {HelpMessage, MoneyInput, Money, Percent},

  props: {
    my: Array,
    statistic: Array,
  },

  data() {
    let percent = 0
    let revenue = 0

    this.my.forEach(v => {
      if (v.status === 'planned' || v.status === 'distributed') {
        percent += v.percent
      }
    })

    this.statistic.forEach(v => {
      if (v.year === lastYear) {
        revenue = v.revenue * 5
      }
    })

    return {
      percent,
      revenue,
    };
  },

  computed: {
    benefit() {
      return this.revenue * this.percent / 100;
    },
    benefitTooltip() {
      return `${money(this.revenue)} × ${formatPercent(this.percent)}`
    }
  },

  methods: {
    formatPercent,
  }
}
</script>
